<template>
    <card class="card-plain">
        <list class="m-0 p-0"
              :columns="columns"
              v-model="teams"
              :actionColumnLabel="$t('Select')">
            <template slot="header">
                <div class="col-lg-12 p-0">
                    <h4 class="d-inline m-0 p-1">{{ $t('Result selection') }}</h4>
                </div>
                <fg-input class="pt-2 pb-2 btn-one-size-dropdown">
                    <el-select size="large"
                               class="select-primary"
                               :placeholder="$t('Time frame')"
                               fullWidth
                               @input="setMonthsFilter"
                               :value="months">
                        <el-option v-for="option in monthsOptions"
                                   :value="option.value"
                                   :label="$t(option.label)"
                                   :key="option.value">
                        </el-option>
                    </el-select>
                </fg-input>
            </template>
            <template slot="actionsByRow" slot-scope="props">
                <router-link class="pr-1" tag="a" :to="{ name: 'WavelineTeamView', params: { qid: $route.params.qid, tid: props.row._id } }">
                    <p-button round type="success" size="sm" icon>
                        <i class="fa fa fa-eye"/>
                    </p-button>
                </router-link>
                <router-link v-if="checkPackage(['premium'])" class="pl-1" tag="a" :to="{ name: 'WavelineUserSelection', params: { qid: $route.params.qid, tid: props.row._id } }">
                    <p-button round type="primary" size="sm" icon>
                        <i class="fa fa-arrow-right"/>
                    </p-button>
                </router-link>
            </template>
        </list>
    </card>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { Select, Option } from 'element-ui'
  import List from '../../Dashboard/Components/BasicList'

  export default {
    name: 'TeamSelection',
    components: {
      List,
      [Select.name]: Select,
      [Option.name]: Option
    },
    data () {
      return {
        sf: 'name',
        so: 'asc',
        columns: [
          { name: 'title', text: 'Name', sortable: false, align: 'left', minWidth: 150 }
        ]
      }
    },

    async mounted () {
      this.init()
    },

    computed: {
      ...mapState('user/waveline', {
        months: state => state.months,
        monthsOptions: state => state.monthsOptions,
      }),
      ...mapState('user/waveline/teamsByQuestionnaire', {
        questionnaire: state => state.questionnaireObj
      }),
      ...mapGetters({ getTeams: 'user/waveline/teamsByQuestionnaire/getTeams' }),
      teams: function () {
        return this.getTeams(this.$route.params.qid)
      },
      breadcrumb: function () {
        const breadcrumb = []
        if (this.questionnaire) {
          breadcrumb.push({ name: 'WavelineQuestionnaireSelection', label: this.$options.filters.languageString(this.questionnaire.title) })
        }
        breadcrumb.push({ name: 'WavelineTeamSelection', label: 'Team selection' })
        return breadcrumb
      }
    },

    methods: {
      ...mapActions('user/waveline/teamsByQuestionnaire', ['getList']),
      ...mapActions('user/waveline', ['setMonthsFilter', 'initPackageMonthsOptions']),
      async init () {
        this.initPackageMonthsOptions(this.$auth.user.customer.settings.contract.packageType)
        await this.fetchTeams()
      },
      async fetchTeams () {
        await this.getList({ questionnaireId: this.$route.params.qid, sf: 'title', so: 'asc', months: this.months })
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      checkPackage(allowedPackages) {
        return allowedPackages.includes(this.$auth.user.customer.settings.contract.packageType)
      }
    },

    watch: {
      months (val) {
        if (val) {
          this.fetchTeams()
        }
      },
      async '$route.params.qid' (val) {
        if (val.length > 1) {
          this.init()
        }
      },
      breadcrumb () {
        this.$store.commit('breadcrumb/SET_ROUTE_DATA', {
          path: this.$route.path,
          breadcrumb: this.breadcrumb
        }, { root: true })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
  }
</style>
